
import { Loader2 } from "lucide-react";
import { useAdminSiteSettings } from "./site-settings/useSiteSettings";
import { SiteSettingsHeader } from "./site-settings/SiteSettingsHeader";
import { ContactInformationCard } from "./site-settings/ContactInformationCard";
import { GeneralSettingsCard } from "./site-settings/GeneralSettingsCard";
import { SocialMediaCard } from "./site-settings/SocialMediaCard";
import { LegalInformationCard } from "./site-settings/LegalInformationCard";

export const SiteSettingsManager = () => {
  const { settings, loading, saving, handleSave, handleInputChange } = useAdminSiteSettings();

  if (loading) {
    return (
      <div className="flex items-center justify-center p-8">
        <div className="text-center">
          <Loader2 className="h-8 w-8 animate-spin text-teedee-blue mx-auto" />
          <p className="mt-2 text-gray-600">Loading settings...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4 md:space-y-6 max-w-full overflow-hidden">
      <SiteSettingsHeader onSave={handleSave} saving={saving} />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
        <ContactInformationCard
          contactEmail={settings.contact_email}
          contactPhone={settings.contact_phone}
          contactAddress={settings.contact_address}
          onInputChange={handleInputChange}
        />

        <GeneralSettingsCard
          siteTitle={settings.site_title}
          siteDescription={settings.site_description}
          onInputChange={handleInputChange}
        />

        <SocialMediaCard
          socialFacebook={settings.social_facebook}
          socialInstagram={settings.social_instagram}
          socialYoutube={settings.social_youtube}
          socialTiktok={settings.social_tiktok}
          onInputChange={handleInputChange}
        />

        <LegalInformationCard
          privacyPolicyContent={settings.privacy_policy_content}
          termsOfServiceContent={settings.terms_of_service_content}
          privacyEffectiveDate={settings.privacy_effective_date}
          termsEffectiveDate={settings.terms_effective_date}
          copyrightStartYear={settings.copyright_start_year}
          legalEmail={settings.legal_email}
          legalPhone={settings.legal_phone}
          legalAddress={settings.legal_address}
          onInputChange={handleInputChange}
        />
      </div>
    </div>
  );
};
